import {Injectable} from '@angular/core';
import {
  PaymentPollingStatus,
  PaymentVerificationResult
} from '@features/payment/domain/model/payment.model';
import {
  PaymentPollingFailedError,
  PaymentPollingTimeoutError
} from '@features/payment/domain/model/payment.errors';

@Injectable({providedIn: 'root'})
export class PaymentStatusTranslator {
  private readonly DEFAULT_ERROR_KEY = new PaymentPollingFailedError().i18nKey;

  translate(status: PaymentPollingStatus): PaymentVerificationResult {
    if (status === PaymentPollingStatus.PROCESSING) {
      throw new PaymentPollingTimeoutError();
    }

    return {
      status,
      error: status === PaymentPollingStatus.FAILED 
      ? this.DEFAULT_ERROR_KEY 
      : undefined,
    };
  }
}
